
import { debounce } from "lodash";
import axios from "axios";

import { fetchWrapper as fetch } from "../helpers/fetch";

axios.defaults.withCredentials = true;
let CancelToken = axios.CancelToken;

const getCsrfToken = () => {
  if (window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.settings && window.__PRELOADED_STATE__.settings.csrfToken) {
    return window.__PRELOADED_STATE__.settings.csrfToken;
  } else {
    return '--no-token--';
  }
};

export type Props = {
  csrfToken: string;
  urls: {
    [key: string]: string;
  } | null;
};

export type ICheckTagNameData = {
  tag?: string;
  name?: string;
};

export type IUpgradeData = {
  type: string;
  level: number;
};

class WscpService {

  csrfToken: string;
  urls: {
    [key: string]: string;
  } | null;

  constructor(props: Props) {
    this.csrfToken = props.csrfToken;
    this.urls = props.urls;
  }

  cancelTokenmap = {};

  sync() {
    axios({
      method: 'get',
      url: 'http://wgcp.portal.loc/gateway/account/wows/sync/',
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=utf-8',
        'X-CSRFToken': this.csrfToken
      }
    }).then(function (response) {}).catch(function (error) {});
  }

  _get() {}

  _parseData(data: any): string {
    let res = '';
    const tempRes = [];
    if (data) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          tempRes.push(`${key}=${data[key]}`);
        }
      }
    }
    return tempRes.join('&');
  }

  _post(url: string, data: any, cancelTokenKey: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.cancelTokenmap[cancelTokenKey]) {
        this.cancelTokenmap[cancelTokenKey]();
        this.cancelTokenmap[cancelTokenKey] = null;
      }
      axios.post(url, this._parseData(data), {
        cancelToken: new CancelToken(c => {
          this.cancelTokenmap[cancelTokenKey] = c;
        }),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-CSRFToken': this.csrfToken,
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(r => {
        if (r.status === 200 && r.data) {
          resolve(r.data);
        } else {
          reject('error');
        }
      }).catch(err => {
        reject(err);
      });
    });

  }

  checkNameTagAvailability(data: ICheckTagNameData): Promise<any> {
    return new Promise((resolve, reject) => {
      this._post('/wows/create/check_name_tag_availability/', data, 'checkNameTagAvailability').then(r => {
        resolve(r);
      }).catch(err => {
        reject(err);
      });
    });
  }

  createClan() {}

  upgradeBuilding(data: IUpgradeData, clanId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = (this.urls && this.urls.upgradeBuilding) ? this.urls.upgradeBuilding.replace('{clan_id}', `${clanId}`) : null;
      if (!url) {
        reject('no url');
        return;
      }
      this._post(url, data, 'upgradeBuilding').then(r => {
        resolve(r);
      }).catch(err => {
        reject(err);
      });
    });
  }


}

export default new WscpService({
  csrfToken: getCsrfToken(),
  urls: window.__PRELOADED_STATE__.urls
});